import gql from "graphql-tag";

export const MY_HR_RESET_2FA = gql`
  mutation reset2fa($email: String!) {
    reset2fa(email: $email)
  }
`;
